// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  civ: __t.string().primaryKey(),
  split: __t.string(),
  source: __t.string(),
  say: __t.string(),
  setEpoch: __t.i64().name("set_epoch"),
  setAt: __t.timestamp().name("set_at"),
});
